<!-- 匹配题类型  匹配题、单词变形 -->
<template>
    <div style="margin-top: 15px;">
        <el-row>
            
            <div v-show="questionindex == question_id" v-for="(item,questionindex) in question_test" :key="questionindex">
                <el-col :span="10">
                    <div :style="`height:${windowHeight-160}px`" class="grid-content">
                        <div class="declare">
                            <h4>Directions:</h4>
                            <div class="declare_html" v-html="item.declare"></div>
                        </div>
                        <div class="content" v-html="item.body"></div>

                    </div>
                </el-col>
                <el-col :span="10">
                    <div :style="`height:${windowHeight-160}px`" class="grid-content">

                        <div v-for="(test_item,test_index) in item.answer" :key="test_index" class="readtest">
                            <div>
                                <h4 style="color: #000000;">{{ test_index+1}}. {{ test_item.question }}</h4>
                                <div class="question_test" ><el-input v-model="answer_data[localQuestionType][questionindex][test_index]" @input="enterAnswer(questionindex,test_index)" placeholder="请输入答案"></el-input></div>

                            </div>
                        </div>
                    </div>
                </el-col>
            </div>
            <el-col :span="4">
                <div :style="`height:${windowHeight-160}px`" class="grid-content">
                    <Scantron :nid="nid" ref="scantron"></Scantron>
                </div>
            </el-col>
        </el-row>
        <div style="width: 100%;display: inline-block;text-align: center;margin-top: 10px;">
            <el-row>
                <el-button size="small" @click="changeQuestion(0)" class="el-icon-arrow-left" type="primary"> 上一题</el-button>
                <el-button size="small" @click="changeQuestion(1)" type="primary">下一题 <i class="el-icon-arrow-right"></i></el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
import Scantron from '/src/units/examination/Scantron.vue';
export default {
    components: { Scantron },
    props:{
        windowHeight:{
            type:Number
        },
        type_data:{
            type:Object
        },
        exam: {
            type: Object
        },
        question_type: {
            type: Number
        },
        fraction_data:{
            type:Object
        },
        nid:{
            type:[Number, String]
        }
    },
    data(){
        return{
            input:[],
   
            question_test: {},
            question_id: '',
            question_number: 0,  //当前题型材料数量
            change_number: 1,    //当前选中第几篇材料
            currentIndex: 0,     //初始化当前题型索引为 0
            index: 0,            //初始化当前题型材料索引为 0
            now_question: [],
            // 新增一个变量来保存 question_type 的值
            localQuestionType: this.question_type,
            answer:'',
            selectedAnswerIndex:'',
            answer_data:{},     //提交的选项
            local_type_data:{},
            local_answer:{},     //本地缓存做题答案

        }
        
    },
    watch: {
        question_type(value) {
            this.localQuestionType = value;
            this.getData()
        }
    },

    activated(){
        //window.sessionStorage.clear()
        //localStorage.setItem('answer_result','')
    },
    mounted(){
        
        setTimeout(()=>{
            this.getData()
            
        },200)
        
    },
    methods:{
  
        enterAnswer(aid, qid){
             
            // //console.log(index,test_index,this.input[test_index]);return

            // // 题型
            var question_type = this.localQuestionType
            if(question_type == 4){
                var answer = this.answer_data[question_type][aid][qid].toUpperCase();
            }else{
                var answer = this.answer_data[question_type][aid][qid];
            }

             
            // // 确保 answer_data 中有 question_type 对应的对象
            if (!this.answer_data[question_type]) {
                this.$set(this.answer_data, question_type, {})
            }

            // // 确保 answer_data[question_type] 中有 aid 对应的对象
            if (!this.answer_data[question_type][aid]) {
                this.$set(this.answer_data[question_type], aid, {})
            }
            
            // // 赋值
            this.$set(this.answer_data[question_type][aid], qid, answer)
            //console.log('填写的答案',qid,this.answer_data[question_type][aid][qid])
            // window.sessionStorage.setItem('row', JSON.stringify(this.answer_data))
            this.$refs.scantron.changeLablePipei(aid, qid, question_type, this.answer_data[question_type][aid][qid])
            //console.log('填写的答案',JSON.stringify(this.answer_data))
            this.$refs.scantron.changQuestionCard(this.answer_data) 
            
        },

        set(currentIndex,number){
            this.currentIndex = currentIndex
            this.index = number
        },

        // type 0 上一题 1下一题
        changeQuestion(type) {
            var params = {}
            params.change_type = type
            if (type === 1) {
                const result = this.switchNext();
                if (!result) {
                    const nextQuestionType = this.switchToNext();

                    if (nextQuestionType) {
                        this.localQuestionType = nextQuestionType;
                        this.getData();
                        this.index = 0;
                        this.question_id = this.now_question[this.index];

                        
                        params.nextQuestionType = nextQuestionType
                        params.currentIndex = this.currentIndex
                        this.$emit('updateQuestion', params);
                    }


                    // if (nextQuestionType) {
                    //     this.localQuestionType = nextQuestionType;
                    //     this.getData();
                    //     this.index = 0;
                    //     this.question_id = this.now_question[this.index];

         
                    //     params.nextQuestionType = nextQuestionType
                    //     params.currentIndex = this.currentIndex
                    //     this.$emit('updateQuestion', params);
                    // }else{
             
                    //     params.nextQuestionType = nextQuestionType
                    //     params.currentIndex = this.currentIndex
                    //     this.$emit('updateQuestion', params);
                    // }
                }
            } else {
                const result = this.switchPrevious();
                if (!result) {
                    const prevQuestionType = this.switchToPrevious();
                    if (prevQuestionType) {
                        this.localQuestionType = prevQuestionType;
                        this.getData();
        
                        //this.index = this.question_number - 1;
                        console.log(this.question_number)
                        this.question_id = this.now_question[this.index];
   
                        params.nextQuestionType = prevQuestionType
                        params.currentIndex = this.currentIndex
                        this.$emit('updateQuestion', params);
                    }
                }
            }
            
            
            //localStorage.setItem('answer_data',window.sessionStorage.getItem('answer_data'))
            // if(localStorage.getItem('row')){
            //     let answer = JSON.parse(localStorage.getItem('row'));

                
            // }
            this.$refs.scantron.changQuestionCard(this.answer_data) 
            
        },
        getData() {
            if(!Object.keys(this.exam).length){

                setTimeout(()=>{
                    this.getData()
                },100)
                return false;
            }
            const data = this.exam;
            const questionType = this.localQuestionType.toString();
            const examData = data[questionType];
            const questionIds = Object.keys(examData);
            this.question_number = questionIds.length;
            this.now_question = questionIds;

            this.$set(this, 'question_test', { ...examData });
            this.$set(this, 'question_id', questionIds[this.index]);
    
            this.nextTickscantron(data,questionType,examData)
        },

        nextTickscantron(data,questionType,examData){
            
            if (this.$refs.scantron) {
                this.$refs.scantron.setData(data, this.type_data,this.fraction_data);
            
                // 填充答案11
                if(localStorage.getItem('answer_result') && Object.keys(JSON.parse(localStorage.getItem('answer_result'))).length){
                    let answer = JSON.parse(localStorage.getItem('answer_result'));
                    this.answer_data = answer
                    this.$refs.scantron.changQuestionCard(this.answer_data) 
                }

                if (!this.answer_data[questionType]) {
                    this.$set(this.answer_data, questionType, {})
                }

                for(var index in examData){

                    if(!this.answer_data[questionType][index]){
                        var result = this.question_test[index].answer
                        this.$set(this.answer_data[questionType],index,result)
                    }
                }
            }else{
                setTimeout(() => {
                    
                    this.nextTickscantron();
                }, 50);
                return false;
            }
        },

        // 下一篇材料
        switchNext() {
            if (this.index < this.now_question.length - 1) {
                this.index++;
            } else {
                return false;
            }
            const currentValue = this.now_question[this.index];
            this.question_id = currentValue;
            return currentValue;
        },
        // 上一篇材料
        switchPrevious() {
            if (this.index > 0) {
                this.index--;
            } else {
                return false;
            }
            const currentValue = this.now_question[this.index];
            this.question_id = currentValue;
            return currentValue;
        },
        // 下一题型
        switchToNext() {
            const questionTypes = this.type_data;
            const keys = Object.keys(questionTypes).map(Number);

            if (this.currentIndex < keys.length - 1) {
                this.currentIndex++;
            } else {
                this.$message({
                    type: 'error',
                    message: '没有更多了'
                });
                return false;
            }
            const currentKey = keys[this.currentIndex];
            
            return currentKey;
        },
        // 上一题型
        switchToPrevious() {
            const questionTypes = this.type_data;
            const keys = Object.keys(questionTypes).map(Number);
            if (this.currentIndex > 0) {
                this.currentIndex--;
            } else {
                this.$message({
                    type: 'error',
                    message: '已经是第一个题了'
                });
                return false;
            }
            const currentKey = keys[this.currentIndex];
            return currentKey;
        }

    }

}
</script>
<style lang="less" scoped>
.declare{

    margin: 0 auto;
    background: #EAF5FB;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 5px;

    .declare_html{
        font-size: 14px;
        line-height: 28px;
    }
}
.content{
    box-sizing: border-box;
    padding: 15px;
    font-size: 14px;
    line-height: 28px;
}

.activ{
    color: #f56c6c !important;
    background: #fef0f0 !important;
    border-color: #fbc4c4 !important;
    font-weight: 700;
}
.grid-content{
    box-sizing: border-box;
    padding: 0 20px;
    border-right: 1px #EAF5FB solid;
    overflow-y: auto;
}
.grid-content::-webkit-scrollbar {  
  width: 10px; /* 滚动条的宽度 */  
}  
  
.grid-content::-webkit-scrollbar-track {  
  background: rgba(0, 0, 0, 0); /* 滚动条轨道的背景色，设置透明度 */  
}  
  
.grid-content::v-deep .el-dialog::-webkit-scrollbar-thumb {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块的颜色，设置透明度 */  
  border-radius: 10px; /* 圆角效果 */  
}  
  
.grid-content::-webkit-scrollbar-thumb:hover {  
  background: rgba(0, 0, 0, 0); /* 滚动条滑块hover时的颜色，设置透明度 */  
}
@media (max-width: 768px) {
    .grid-content {
        height: auto !important;
        padding: 5px;
    }

    .el-row {
        flex-direction: column;
    }

    .el-col {
        width: 100%;
        height: auto !important;
    }

    .el-col:first-child {
        order: 1;
    }

    .el-col:last-child {
        order: 2;
    }

    .declare, .content {
        font-size: 12px;
    }

    .question_test {
        padding: 6px 10px;
        font-size: 12px;
    }
}
</style>